import React, { Fragment, useEffect } from "react";
import EnquiryForms from "../EnquiryForms/EnquiryForms";
import StockReorder from "../../add-edit-product/stock-reorder/StockReorder";
import DeliveryProfileSection from "../delivery-slider/DeliveryProfileSection";

const EnquiryDeliveryStockContainer = (props) => {
    const { productData={}, permissions={}, selectedCategoryType={}, selectedType } = props;
    const productOrService = selectedType != "service" ? true: false;
    const { isSellOnline=null, enquiryFormId=null } = productData;
    
    return (
        <Fragment>
            {!isSellOnline && <EnquiryForms enquiryFormId={enquiryFormId}  />}
            {isSellOnline ? <DeliveryProfileSection {...props} /> : null}
            {productOrService ? <StockReorder {...props} /> : null}
        </Fragment>
    );
}

export default React.memo(EnquiryDeliveryStockContainer);